import _ from 'lodash'
import React, { useMemo } from 'react'
import { LevelHeader, SectionHeader } from '../schedule/SectionHeader'

export const Scoreboard = ({
  lsdm,
  scheduleLevelKeys,
  selectedDate
}) => {

  console.log('!lsdmdd', lsdm)
  console.log('selectedDate', selectedDate)
  const _selectedDate = '09/04/2025'

  const levelDateMatches = (matchesBySection) => {
    console.log('matchesBySection', matchesBySection)
    if (matchesBySection) {
      const sms = _.map(matchesBySection, (sectionMatches, sectionKey) => {
        console.log('sectionMatches', sectionKey, sectionMatches)
        return <div style={{ padding: '1em' }}>{sectionKey}</div>
      })
      return sms
    }
    return <div style={{ padding: '1em' }}>No Matches</div>
  }

  const scoreboard = useMemo(() => {
    const scoreboards = _.map(scheduleLevelKeys, levelKey => {
      const _lsdm = lsdm?.[levelKey]
      const matchesBySection = _lsdm?.[_selectedDate]
      const levelHeader = <LevelHeader levelKey={levelKey} />
      return <div className='scoreboard'>
        {levelHeader}
        {levelDateMatches(matchesBySection)}
      </div>
    })
    return scoreboards
  }, [selectedDate])

  return (
    <div className='scoreboard'>
      {scoreboard}
    </div>

  )
}
